let moment = require("jalali-moment");

let enDate = new Date();
let dd = String(enDate.getDate()).padStart(2, "0");
let mm = String(enDate.getMonth() + 1).padStart(2, "0"); //January is 0!
let yyyy = enDate.getFullYear();

enDate = yyyy + "/" + mm + "/" + dd;

let faDate =  moment(enDate).locale("fa").format("YYYY/MM/DD");

const customDayDate = (day = 0) => {
  let newDate = new Date();
  newDate.setDate(newDate.getDate() + day);
  let dd = String(newDate.getDate()).padStart(2, "0");
  let mm = String(newDate.getMonth() + 1).padStart(2, "0"); //January is 0!
  let yyyy = newDate.getFullYear();
  newDate = yyyy + "-" + mm + "-" + dd;

  const m = moment(newDate);
  m.locale("fa");
  m.format("YYYY-MM-DD");

  console.log(faDate);

  return m.format("YYYY/MM/DD");
};

export { enDate, faDate, customDayDate };
